import React, { useState } from "react";
import tabBg from "../../assets/page icons/grediyent box.png";
import motionIcon from "../../assets/page icons/minimized.png";
import StableIcon from "../../assets/page icons/stable.png";
import HeatIcon from "../../assets/page icons/heat.png";
import MoistureIcon from "../../assets/page icons/moisture.png";
import WaterfallIcon from "../../assets/page icons/waterfall.png";
import NaturalIcon from "../../assets/page icons/100%Natural.png";
import biodegradableIcon from "../../assets/page icons/FullyBiodegradable.png";
import ReducedlandfillwasteIcon from "../../assets/page icons/icons_reduced.png";
import EnergyEfficientIcon from "../../assets/page icons/Energy-efficient.png";
import HypoallergenicIcon from "../../assets/page icons/Hypoallergenic.png";
import CoolingIcon from "../../assets/page icons/Cooling.png";
import EnhancedIcon from "../../assets/page icons/Enhanced.png";
import spineIcon from "../../assets/page icons/spine.png";

export default function WhatMatters() {
  const [activeTab, setActiveTab] = useState("Health");

  const tabs = ["Health", "Sustainability", "Quality"];

  const content = {
    Health: [
      {
        icon: HypoallergenicIcon,
        title: "Hypoallergenic sleep environment",
        desc: "Natural latex is resistant to microbes and allergens, and has no synthetic irritants",
      },
      {
        icon: CoolingIcon,
        title: "Cooling effect",
        desc: "Natural latex allows air to circulate freely, releasing trapped heat, and maintaining a naturally breathable, thermally neutral sleep surface",
      },
      {
        icon: EnhancedIcon,
        title: "Enhanced hygiene",
        desc: "Lexus profile foam absorbs lesser moisture, and is easier to clean and maintain",
      },
      {
        icon: spineIcon,
        title: "Strong spine support",
        desc: "RBF offers firm, uniform, and sag-resistant backing that keeps the spine aligned, distributes body weight evenly, and ensures long-term orthopaedic stability",
      },
    ],
    Sustainability: [
      {
        icon: NaturalIcon,
        title: "100% natural",
        desc: "Natural latex is derived from the sap of rubber trees, a renewable resource",
      },
      {
        icon: biodegradableIcon,
        title: "Fully biodegradable",
        desc: "Natural latex can break down naturally at the end of its life cycle, and contains no synthetic chemicals, VOCs, or heavy metals",
      },
      {
        icon: ReducedlandfillwasteIcon,
        title: "Reduced landfill waste",
        desc: "Natural latex is extremely resilient and durable, often lasting 2-3 times longer than conventional PU foam, reducing mattress replacement frequency, lowering overall waste generation",
      },
      {
        icon: EnergyEfficientIcon,
        title: "Energy-efficient",
        desc: "Producing natural latex foam uses less energy and emits fewer greenhouse gases than manufacturing synthetic or memory foams",
      },
    ],
    Quality: [
      {
        icon: motionIcon,
        title: "Minimized motion transfer",
        desc: "Lexus profile foam has a contoured, shock-absorbing design that isolates movement, dissipates energy, and ensures each sleeper's side remains stable and undisturbed",
      },
      {
        icon: StableIcon,
        title: "Stable, undisturbed sleep",
        desc: "Anti-skid fabric reduces mattress movement, preventing unwanted shifting during sleep or use",
      },
      {
        icon: HeatIcon,
        title: "Heat dissipation",
        desc: "Lexus profile foam gently compresses and decompresses, pushing stale air out and drawing fresh air in-a natural ventilation cyce that prevents stuffiness",
      },
      {
        icon: MoistureIcon,
        title: "Moisture prevention",
        desc: "Lexus profile foam absorbs less moisture and sweat, which helps prevent mould, mildew, and bacterial growth, enhancing the life and usage experience of the mattress",
      },
      {
        icon: WaterfallIcon,
        title: "Waterfall finish",
        desc: "Seamless, wrap-over cover design without any piping or visible stitching along the edges for enhanced elegance and style",
      },
    ],
  };

  return (
    <div className="relative bg-[#001321] bg-no-repeat w-full background overflow-hidden">
      <div className="sm:max-w-full max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto sm:px-5 md:px-0  pt-28 md:pt-40 pb-10 xl:pb-28  text-white">
        <h2
          className="text-[20px] md:text-[4.5rem] font-lexend font-extralight w-[50%] md:w-[80%] xl:w-[35%] leading-[22px] md:leading-[4rem]"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          What Matters to you most?
        </h2>
        <p
          className="text-[#accafc] text-[12px] xl:text-[20px] font-lexend font-extralight w-[75%] md:w-[60%] xl:w-[25%] py-3 xl:py-7"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Know more about how this mattress performs on the aspects you care
          most deeply about.
        </p>
        {/* Tabs & Content */}
        <div className="flex flex-col xl:flex-row pt-6 xl:pt-28 gap-6 md:gap-16">
          {/* Left Tabs (40%) */}
          <div
            className="
      w-full xl:w-[40%]
      flex flex-row xl:flex-col
      gap-3 xl:gap-0 xl:space-y-3
      text-[18px] md:text-[32px] xl:text-[45px] 3xl:text-[52px]
      font-lexend font-extralight
    "
          >
            {tabs.map((tab) => {
              const isActive = activeTab === tab;

              return (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`relative
            flex items-center justify-center xl:justify-start
            text-center xl:text-left 
             xl:pl-16 xl:h-52 md:text-3xl
            w-full lg:text-[64px] xl:text-[52px]
            transition-all duration-500
            ${isActive ? "text-white" : "text-[#42659d]"}
          `}
                >
                  {/* Left Gradient Bar — XL only */}
                  <span
                    className={`hidden xl:block xl:absolute left-0 top-0 h-full transition-all duration-500 ${
                      isActive
                        ? "w-[10px] bg-[#194083]"
                        : "w-[10px] bg-[#053354]"
                    }`}
                  ></span>

                  {/* Active Background — XL only */}
                  {isActive && (
                    <span
                      className="hidden xl:block xl:absolute inset-0 bg-no-repeat bg-cover pointer-events-none"
                      style={{
                        backgroundImage: `url(${tabBg})`,
                      }}
                    ></span>
                  )}

                  <span className="relative z-10 font-lexend font-extralight">
                    {tab}
                  </span>
                </button>
              );
            })}
          </div>

          {/* Right Content (60%) */}
          <div className="w-full xl:w-[60%] mx-auto grid gap-[1px] xl:gap-[2px]">
            {content[activeTab].map((item, index) => {
              const isFirst = index === 0;
              const isLast = index === content[activeTab].length - 1;

              return (
                <div
                  key={index}
                  className={`flex items-center justify-start
            gap-4 sm:gap-2 xl:gap-6
            bg-[#042b62]  overflow-hidden
            ${isFirst ? "rounded-t-2xl" : ""}
            ${isLast ? "rounded-b-2xl" : ""}
          `}
                >
                  {/* Icon Section */}
                  <div
                    className="  overflow-hidden
              flex-shrink-0 flex items-center justify-start xl:justify-center
              bg-[#194083] 
              py-6 px-5 xl:py-10 xl:px-12
            "
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="object-cover xxs:w-20"
                    />
                  </div>

                  {/* Text Section */}
                  <div className="text-left  xl:py-0">
                    <h3 className="text-[#c7e5fd] font-lexend font-semibold text-[12px] xl:text-[18px] 3xl:text-[20px] md:pb-2">
                      {item.title}
                    </h3>
                    <p className="text-[#88c1ea] text-[10px] xl:text-[15px] 3xl:text-running font-lexend font-extralight leading-relaxed w-full xl:w-[90%]">
                      {item.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
